import React, { useState } from 'react';

import GiveOrder from './GiveOrder';
import ChangeStatus from './ChangeStatus';
import ControlCenter from './ControlCenter';
import SupportCenter from './SupportCenter';
import ShippingCenter from './ShippingCenter';
import ShippingRequest from './ShippingRequest';
import FinancialCenter from './FinancialCenter';
import HistoryCenter from './HistoryCenter';
import { CountdownTimer } from 'components';

import {
  Box,
  Card,
  Fade,
  Stack,
  Button,
  Popover,
  Typography,
  CardHeader,
  CardActions,
  CardActionArea,
} from '@mui/material';

export default function Model({ model, delay, checked, refetch, isAssign, selectable, handleSelect }) {
  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row">
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              borderColor: checked && 'primary.main',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              title={
                <Stack rowGap={0.5} alignItems="flex-start">
                  <Typography variant="subtitle1" color="text.secondary" fontSize={16} letterSpacing={3}>
                    {model.tracking_code.split('.')[1]}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" fontSize={14}>
                    {`${model?.customer?.firstname} ${model?.customer?.lastname}`}
                  </Typography>
                </Stack>
              }
              action={
                model.status?.id === '21' ? (
                  model.shipping?.type.id === '2' ? (
                    <GiveOrder ids={model.id} refetch={refetch} />
                  ) : (
                    <ShippingRequest ids={model.id} shop={model?.shop?.id} refetch={refetch} />
                  )
                ) : (
                  <ChangeStatus model={model.id} status={model.status?.id} refetch={refetch} />
                )
              }
            />
            <CardActions sx={{ justifyContent: 'space-between' }}>
              <DatePopover created={model.created_at} demanded={model.demand_time} delivered={model.delivery_time} />
              <Stack direction="row" alignItems="center" columnGap={0.5}>
                <ControlCenter model={model} refetch={refetch} />
                <HistoryCenter model={model} refetch={refetch} />
                <SupportCenter model={model} refetch={refetch} />
                <FinancialCenter model={model} refetch={refetch} />
                <ShippingCenter model={model} refetch={refetch} />
              </Stack>
            </CardActions>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}

const OrderDate = ({ title, date, color = 'warning.darker', bgcolor = 'warning.lighter' }) =>
  date && (
    <Stack direction="row" columnGap={1} alignItems="center">
      <Typography width={80} variant="subtitle1" fontSize={12}>
        {title}
      </Typography>
      <CountdownTimer targetDate={date} color={color} bgcolor={bgcolor} />
    </Stack>
  );

const DatePopover = ({ created, demanded, delivered }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        size="small"
        color="inherit"
        aria-owns={open ? `mouse-over-popover-date` : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {demanded ? (
          <CountdownTimer targetDate={demanded} color="warning.darker" bgcolor="warning.lighter" />
        ) : (
          <CountdownTimer targetDate={created} color="info.darker" bgcolor="info.lighter" />
        )}
      </Button>
      <Popover
        id={`mouse-over-popover-date`}
        sx={{
          pointerEvents: 'none',
          direction: 'ltr',
          bgcolor: 'transparent',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        hideBackdrop
      >
        <Stack p={1} rowGap={1} bgcolor="transparent">
          <OrderDate title="تاریخ ثبت" date={created} />
          <OrderDate title="تاریخ درخواست" date={demanded} />
          <OrderDate title="تاریخ تحویل" date={delivered} color="success.darker" bgcolor="success.lighter" />
        </Stack>
      </Popover>
    </Box>
  );
};
